import {inject, observer} from 'mobx-react';
import React, {useEffect, useState} from 'react';
import CourseLevelAnalyticsRootUI from '../view/CourseLevelAnalyticsRootUI';
import {FetchCoursesShortListModel} from '../../../../data/models/AI/AiAssistantModels';
import {useNavigate, useParams} from 'react-router-dom';
import CourseLevelAnalyticsRootStore from '../store/CourseLevelAnalyticsRootStore';
import {CourseAnalyticsData} from '../../../../data/models/Gradebook/CourseAnalyticsModels';

interface Props {
  courseLevelAnalyticsRootStore?: CourseLevelAnalyticsRootStore;
}

const CourseLevelAnalyticsRootContainer = inject(
  'courseLevelAnalyticsRootStore',
)(
  observer(({courseLevelAnalyticsRootStore}: Props) => {
    const [courses, setCourses] = useState<FetchCoursesShortListModel[]>([]);
    const [courseData, setCourseData] = useState<CourseAnalyticsData>();
    const [selectedCourse, setSelectedCourse] = useState('');
    const {courseId, organizationId} = useParams();
    const navigate = useNavigate();

    useEffect(() => {
      if (courseId && organizationId) {
        setSelectedCourse(courseId);
        courseLevelAnalyticsRootStore!
          .getCoursesList(organizationId, '')
          .then(res => {
            setCourses(
              res.sort((x, y) =>
                x.title.toLowerCase() > y.title.toLowerCase() ? 1 : -1,
              ),
            );
          });
        courseLevelAnalyticsRootStore!
          .getCourseAnalytics(organizationId, courseId)
          .then(setCourseData);
      }
    }, [courseId]);

    useEffect(() => {
      if (selectedCourse !== courseId && selectedCourse) {
        setSelectedCourse('');
        navigate(
          `/manage/${organizationId}/analytics/course/${selectedCourse}/learners`,
        );
      }
    }, [selectedCourse]);

    const onBack = () => {
      navigate(`/manage/${organizationId}/analytics`, {replace: true});
    };

    return (
      <CourseLevelAnalyticsRootUI
        courses={courses}
        selectedCourse={selectedCourse}
        setSelectedCourse={setSelectedCourse}
        organizationId={organizationId || ''}
        courseAnalyticsData={courseData}
        onBack={onBack}
      />
    );
  }),
);

export default CourseLevelAnalyticsRootContainer;
